import "react/jsx-runtime";
import { typography } from "../../../themes/typography/typography.js";
import "color-alpha";
import "@mui/material";
import "../../../themes/external-theme/external-theme.js";
import "../../../themes/pickers-popper/pickers-popper.js";
import "../../../themes/shadows/shadows.js";
import "../../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../../themes/typography/utils/typographyVariants/typographyVariants.js";
import "../../../constants/breakpoints/breakpoints.js";
import "../../../constants/create-theme/create-theme.js";
import "@mui/material/styles";
import "../../../constants/colors/palette.js";
import "../../../themes/alert/alert.js";
import "../../../themes/alert/components/ErrorIcon/ErrorIcon.js";
import "@mui/material/SvgIcon/index.js";
import "../../../themes/alert/components/InfoIcon/InfoIcon.js";
import "../../../themes/alert/components/SuccessIcon/SuccessIcon.js";
import "../../../themes/alert/components/WarningIcon/WarningIcon.js";
import "../../../themes/button/button.js";
import "../../../themes/button/styles/external/bordered.styles.js";
import "../../../themes/button/styles/external/filled.styles.js";
import "../../../themes/button/styles/internal/bordered.styles.js";
import "../../../themes/button/styles/internal/borderless.styles.js";
import "../../../themes/button/styles/internal/filled.styles.js";
import "../../../themes/button/styles/internal/shadowed.styles.js";
import "../../../themes/checkbox/checkbox.js";
import "../../../themes/checkbox/components/CheckedIcon/CheckedIcon.js";
import "../../../themes/checkbox/components/IndeterminateIcon/IndeterminateIcon.js";
import "../../../themes/form-control-label/form-control-label.js";
import "../../../themes/radio/radio.js";
import "../../../themes/switch/switch.js";
const wrapper = {
  display: "flex",
  flexDirection: "column",
  gap: 2,
  color: "grey.800"
};
const title = {
  ...typography["Lato H5 Bold"],
  mb: 3,
  textAlign: "center"
};
const hint = { mb: 3 };
const questionContainer = {
  p: 2,
  boxShadow: "0px 0.5px 1px 0px rgba(0, 0, 0, 0.35), 0px -0.5px 0.5px 0px rgba(0, 0, 0, 0.1)",
  borderRadius: 2,
  backgroundColor: "common.white"
};
const questionLabel = {
  ...typography["Lato Emphasized 1"]
};
const answersContainer = {
  display: "flex",
  flexDirection: "column",
  mt: 1
};
const sliderContainer = {
  mt: 5,
  px: 2,
  mb: 2.5
};
const sliderLabel = (isActive, shouldHideLabel) => ({
  ...typography["Lato Caption Small Bold"],
  color: "grey.800",
  top: "40px",
  transform: "translate(-50%, 0%)",
  maxWidth: "30px",
  whiteSpace: "break-spaces",
  textAlign: "center",
  position: "absolute",
  ...isActive ? { color: "primary.800" } : {},
  display: shouldHideLabel ? "none" : "initial",
  wordBreak: "normal"
});
export {
  answersContainer,
  hint,
  questionContainer,
  questionLabel,
  sliderContainer,
  sliderLabel,
  title,
  wrapper
};
